import moment from "moment";
import React from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { BooleanBadge, StatusBadge } from "../utils";

const EligibilityPayerResponse = () => {
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const responsePayerPersonal = eligibilityCheckData?.payer_response;
  const eligibilityStatus = eligibilityCheckData?.eligibility_status;

  // Define fields to render, reducing conditional repetition
  const fields = [
    { label: "Payer Name", value: responsePayerPersonal?.payer_name },
    { label: "Reference Number", value: responsePayerPersonal?.reference_no },
    { label: "Status", value: <StatusBadge status={eligibilityStatus} /> },
    { label: "Request Bundle ID", value: responsePayerPersonal?.requestid },
    { label: "Response Bundle ID", value: responsePayerPersonal?.responseid },
    {
      label: "Requested At",
      value: responsePayerPersonal?.requestat
        ? moment(responsePayerPersonal?.requestat).format(
          "DD-MM-YYYY hh:mm:ss A"
        )
        : "",
    },
    { label: "Eligibility ID", value: responsePayerPersonal?.eligibility_id },
    {
      label: "Outcome",
      value: responsePayerPersonal?.outcome && (
        <span
          className={`text-${responsePayerPersonal?.outcome === "complete" ? "success" : "danger"
            } fs-10`}
        >
          {responsePayerPersonal?.outcome}
        </span>
      ),
    },
    {
      label: "Eligibility Description",
      value: responsePayerPersonal?.description,
      condition: !!responsePayerPersonal?.description,
    },
    { label: "Eligibility Code", value: responsePayerPersonal?.code },
    {
      label: "Expiry Date",
      value: responsePayerPersonal?.serviceto,
      condition:
        !!responsePayerPersonal?.serviceto ||
        !!responsePayerPersonal?.servicefrom,
    },
    {
      label: "Inception Date",
      value: responsePayerPersonal?.servicefrom,
      condition:
        !!responsePayerPersonal?.serviceto ||
        !!responsePayerPersonal?.servicefrom,
    },
    {
      label: "Transfer",
      value: responsePayerPersonal?.transfer !== undefined && (
        <BooleanBadge value={responsePayerPersonal?.transfer} />
      ),
    },
    {
      label: "Emergency",
      value: responsePayerPersonal?.emergency !== undefined && (
        <BooleanBadge value={responsePayerPersonal?.emergency} />
      ),
    },
    {
      label: "Newborn",
      value: responsePayerPersonal?.newborn !== undefined && (
        <BooleanBadge value={responsePayerPersonal?.newborn} />
      ),
    },
    {
      label: "Remark",
      condition: true,
      value: (
        <div
          className={`${responsePayerPersonal?.outcome === "error" ? "text-danger" : ""
            }`}
        >
          {responsePayerPersonal?.outcome === "error" &&
            responsePayerPersonal?.error?.map((item, index) => (
              <div key={index}>
                {item?.error_code
                  ? `(${item?.error_code || ""}) - ${item?.error_codemsg || ""}`
                  : item?.error_codemsg || ""}
              </div>
            ))}
          {responsePayerPersonal?.remark && (
            <div className={responsePayerPersonal?.outcome === "error" ? "text-danger fs-11 mt-1" : "text-danger"}>
              {responsePayerPersonal?.remark}
            </div>
          )}
          {!responsePayerPersonal?.remark && responsePayerPersonal?.outcome !== "error" && ""}
        </div>
      ),
    },
  ];

  // Filter fields with values or explicit conditions
  const payerData = fields.filter(
    (item) => (item.condition !== false && item.value) || item.condition
  );

  return (
    <div className="d-flex flex-column gap-2">
      <div className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success w-50 p-3">
        <InfoCircle className="fs-9" />
        <span className="fs-10">Payer Response</span>
      </div>

      <div className="mt-3">
        {payerData.map((item, index) => (
          <Row
            key={index}
            className="border-bottom border-dashed pb-2 mb-2 align-items-center"
          >
            <Col xs={5} className="text-700 fs-11 fw-bolder">
              {item.label}
            </Col>
            <Col xs={7} className="text-500 fs-11 fw-600">
              {item.value}
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
};

export default EligibilityPayerResponse;
